class PingService {
    constructor() {   
        this.intervalId = null; 
    }
   startTimer(){
     // Stop the previous interval if it exists
    this.stopTimer();
    this.intervalId =  setInterval(function () {
        const currentTimestamp = new Date().getTime();
        localStorage.setItem('userLastSeen', currentTimestamp.toString());
    }, 1000); // 5000 milliseconds (5 seconds)
   }
   stopTimer() {
        if (this.intervalId !== null) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
  
  }
  export default new PingService();